import { FC } from 'react';
import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps, styled } from '@mui/material';
import classNames from 'classnames';

export type AvatarProps = MuiAvatarProps & {
  color?: 'primary' | 'secondary';
  size?: 'huge' | 'large' | 'medium' | 'small' | 'tiny';
};

const StyledAvatar = styled(MuiAvatar)`
  &.size {
    &--tiny {
      height: 14px;
      width: 14px;
    }

    &--small {
      height: 18px;
      width: 18px;
    }

    &--medium {
      height: 28px;
      width: 28px;
      font-size: 0.9rem;
    }

    &--large {
      height: 36px;
      width: 36px;
    }

    &--huge {
      height: 4rem !important;
      width: 4rem !important;
      font-size: 2rem !important;
    }
  }

  &.color {
    &--primary {
      background: ${({ theme }) => theme.palette.primary.main};
      color: ${({ theme }) => theme.palette.getContrastText(theme.palette.primary.main)};
    }

    &--secondary {
      background: ${({ theme }) => theme.palette.secondary.main};
      color: ${({ theme }) => theme.palette.getContrastText(theme.palette.secondary.main)};
    }
  }
`;

export const Avatar: FC<AvatarProps> = ({ className, color, size = 'medium', ...rest }) => (
  <StyledAvatar
    className={classNames(className, `size--${size}`, { [`color--${color}`]: !!color })}
    {...rest}
  />
);

Avatar.displayName = 'Avatar';
